"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchIcon = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const IconContainer_1 = __importDefault(require("./IconContainer"));
const SearchIcon = (_a) => {
    var { className, size, title } = _a, props = __rest(_a, ["className", "size", "title"]);
    return (react_1.default.createElement(IconContainer_1.default, Object.assign({ className: (0, classnames_1.default)("gerudo-icon-cancel", size, className) }, props),
        react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", x: "0px", y: "0px", viewBox: "0 0 25.207 25.207", "aria-label": title, role: "img" },
            react_1.default.createElement("title", null, title),
            react_1.default.createElement("g", { id: "Calque_28", "data-name": "Calque 28" },
                react_1.default.createElement("line", { x1: "24.5", y1: "24.5", x2: "15.357", y2: "15.357", fill: "none", stroke: "currentColor", strokeMiterlimit: "10", strokeWidth: "2" }),
                react_1.default.createElement("circle", { cx: "9.643", cy: "9.643", r: "8.643", fill: "none", stroke: "currentColor", strokeMiterlimit: "10", strokeWidth: "2" })))));
};
exports.SearchIcon = SearchIcon;
SearchIcon.defaultProps = {
    title: "Search",
};
exports.default = SearchIcon;
//# sourceMappingURL=Search.js.map